// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"44508811","239":"7f433fbd","453":"35b456d2","455":"849c451f"}[chunkId] + ".chunk.js";
};